import React, { useEffect, useState } from 'react';
import { Card, CardContent, Divider, Grid, Link, makeStyles, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';

import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import HomeTwoToneIcon from '@material-ui/icons/HomeTwoTone';
import HomeIcon from '@material-ui/icons/Home';

import { gridSpacing } from '../../Backbone/constant';

import PagePath, { PageType } from '../../Route/PagePath';
import { useSelector } from 'react-redux';
import { RootReduxState } from '../../Redux/Store';

const useStyles = makeStyles((theme) => ({
    link: {
        display: 'flex',
        color: theme.palette.grey[900],
        textDecoration: 'none',
        alignContent: 'center',
        alignItems: 'center'
    },
    activeLink: {
        display: 'flex',
        textDecoration: 'none',
        alignContent: 'center',
        alignItems: 'center',
        color: theme.palette.grey[500]
    },
    icon: {
        marginRight: theme.spacing(0.75),
        marginTop: '-' + theme.spacing(0.25),
        width: '1rem',
        height: '1rem',
        color: theme.palette.purple.main
    },
    content: {
        padding: '16px !important'
    },
    noPadding: {
        padding: '16px !important',
        paddingLeft: '0 !important'
    },
    card: {
        marginBottom: theme.spacing(2)
    },
    root: {
        background: 'transparent',
        boxShadow: 'none',
        border: 'none'
    },
    titleTop: {
        marginBottom: theme.spacing(1)
    },
    titleBottom: {
        marginTop: theme.spacing(1)
    },
    divider: {
        borderColor: theme.palette.primary.main,
        marginBottom: theme.spacing(gridSpacing)
    }
}));

type BreadcrumbProps = Omit<React.ComponentProps<typeof Card>, 'children' | 'title'> & {
    separator?: React.ElementType<{ stroke?: number; size?: string }>;
    title?: boolean;
    titleBottom?: boolean;
    icons?: boolean;
    icon?: boolean;
    maxItems?: number;
    card?: boolean;
    divider?: boolean;
    rightAlign?: boolean;
    navigation: PagePath[];
};

const Breadcrumbs = (props: BreadcrumbProps) => {
    const classes = useStyles();
    const { separator, title, titleBottom, icons, icon, maxItems, card, divider, rightAlign, ...rest } = props;
    //var tempPage = {} as unknown as PagePath
    const [main, setMain] = useState<PagePath | null>(null);
    const [item, setItem] = useState<PagePath | null>(null);

    const ShowBreadcrumb = useSelector((state: RootReduxState) => state.customization.ShowBreadcrumb);

    const getCollapse = (item: PagePath) => {
        if (item.content?.length) {
            item.content.filter((collapse: PagePath) => {
                if (collapse.content?.length) {
                    getCollapse(collapse);
                } else {
                    if (document.location.pathname === collapse.to) {
                        setMain(item);
                        setItem(collapse);
                    }
                }
                return false;
            });
        }
        else {
            if (document.location.pathname === item.to) {
                setMain(null);
                setItem(item);
            }
        }
    }



    useEffect(() => {
        props.navigation.map((item: PagePath, index: number) => {
            //if (item.type && item.type === 'group') {

            getCollapse(item);
            // }
            return false;
        });
    });

    const SeparatorIcon = separator;
    const separatorIcon = SeparatorIcon ? <SeparatorIcon stroke={1.5} size="1rem" /> : '/';

    let cardClass = classes.card;
    if (card === false) {
        cardClass = classes.root;
    }

    let contentClass = classes.content;
    if (card === false) {
        contentClass = classes.noPadding;
    }

    let mainContent, itemContent;
    let breadcrumbContent = <></>;
    let itemTitle = '';
    let CollapseIcon;
    let ItemIcon;

    if (main) {
        CollapseIcon = main.icon ? main.icon : AccountTreeTwoToneIcon;
        mainContent = (
            <Link component={RouterLink} to="#" variant="subtitle1" className={classes.link}>
                {icons && <CollapseIcon className={classes.icon} />}
                {main.label}
            </Link>
        );
    }

    if (item && item.type === PageType.item) {
        itemTitle = item.label;

        ItemIcon = item.icon ? item.icon : AccountTreeTwoToneIcon;
        itemContent = (
            <Typography variant="subtitle1" className={classes.activeLink}>
                {icons && <ItemIcon className={classes.icon} />}
                {itemTitle}
            </Typography>
        );

        if (ShowBreadcrumb) {
            breadcrumbContent = (
                <Card elevation={0} className={cardClass} {...rest}>
                    <CardContent className={contentClass}>
                        <Grid
                            container
                            direction={rightAlign ? 'row' : 'column'}
                            justify={rightAlign ? 'space-between' : 'flex-start'}
                            alignItems={rightAlign ? 'center' : 'flex-start'}
                            spacing={1}
                        >
                            {title && !titleBottom && (
                                <Grid item>
                                    <Typography variant="h3"> {item.label} </Typography>
                                </Grid>
                            )}
                            <Grid item>
                                <MuiBreadcrumbs aria-label="breadcrumb" maxItems={maxItems ? maxItems : 8} separator={separatorIcon}>
                                    <Link component={RouterLink} to="/" color="inherit" variant="subtitle1" className={classes.link}>
                                        {icons && <HomeTwoToneIcon className={classes.icon} />}
                                        {icon && <HomeIcon className={classes.icon} style={{ marginRight: 0 }} />}
                                        {!icon && 'Dashboard'}
                                    </Link>
                                    {mainContent}
                                    {itemContent}
                                </MuiBreadcrumbs>
                            </Grid>
                            {title && titleBottom && (
                                <Grid item>
                                    <Typography variant="h3"> {item.label} </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                    {card === false && divider !== false && <Divider className={classes.divider} />}
                </Card>
            );
        }

        // document.title = itemTitle + config.title;
    }

    return breadcrumbContent;
};

export default Breadcrumbs;
